module.exports = __webpack_public_path__ + "assets/img/chengben.91d7affa.png";